export default __webpack_public_path__ + "img/2c36e2021bb46b8886472f018861f5da.png";